export default __webpack_public_path__ + "static/media/certificate2Small.ebfcebf7.webp";